import React from "react";
import Covid19VaccineProviderLocations from "./Covid19VaccineProviderLocations";

function Covid19VaccineProviderDetails({ showProviderDetails, prov, defaultPhone }) {

    const indexOfLocation = 0;
    const specialties = prov.specialties ? prov.specialties.map((s, i) => {
        return <div className="col-12 item-specialty" key={i}>{s.Specialty}</div>;
    }) : [];
    const defaultProvPhoto = '/images/location-pic.png';
    const provPhoto = prov.photo ? prov.photo : defaultProvPhoto;

    return (
        <div className={"col item-profile-container"}>
            <div className="row">
                <div className="col-12">
                    {showProviderDetails && <div className="item-avatar-container">
                        <div className="item-img-container" style={{ backgroundImage: `url(${provPhoto})` }} >
                            <div className="item-img" />
                        </div>
                    </div>}
                    <div className={"item-details"}>
                        {showProviderDetails && <div className="row">
                            <div className="col-12 item-name">
                                {prov.displayName ? prov.displayName
                                    : <div className="no-data-dash">
                                        <div />
                                    </div>
                                }
                            </div>
                            {specialties && specialties.length > 0 ? specialties[0] : ""}
                        </div>}
                        <div className="row">
                            <Covid19VaccineProviderLocations prov={prov} showProviderDetails={showProviderDetails} />
                            {showProviderDetails && <div className="col-12 item-phone">
                                <a className={defaultPhone ? "phone-link" : "no-link"} href={defaultPhone ? "tel:" + (defaultPhone) : "#"}>
                                    <div className="details-icon-prepend">
                                        <div className="icon-col">
                                            <span className="icon-phone" />
                                        </div>
                                        <div className="details-col">
                                            {defaultPhone ?
                                                <div>{defaultPhone}</div>
                                                : <div className="no-data-dash">
                                                    <div />
                                                </div>}
                                        </div>
                                    </div>
                                </a>
                            </div>}
                        </div>
                        {showProviderDetails &&
                            <div className="row">
                                <div className="col-12 item-hours">
                                    <div className="details-icon-prepend">
                                        <div className="icon-col">
                                            <span className="icon-clock" />
                                        </div>
                                        <div className="details-col">
                                            {prov.locations && prov.locations.length > 0 && prov.locations[indexOfLocation].openNowMessage && prov.locations[indexOfLocation].openNowMessage.indexOf('www') === -1
                                                    ? <div>{prov.locations[indexOfLocation].openNowMessage}</div>
                                                    : <div className="no-data-dash">
                                                        <div />
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Covid19VaccineProviderDetails;